<template>
  <FormItem v-bind="{label, prop, labelWidth}">
    <VueSelect
      v-model="val"
      v-bind="{options, placeholder, disabled, loading,searchable}"
      class="base-vue-select"
      transition="none"
      max-height="200px"
    />   
    <Spin
      v-if="loading"
      fix
    />
  </FormItem>
</template>

<script>
  import { FormItem, Spin } from 'iview';
  import VueSelect from 'vue-select';

  export default {
    components: { FormItem, Spin, VueSelect },
    props: {
      label: {
        type: String,
        default: null
      },
      labelWidth: {
        type: Number,
        default: null
      },
      prop: {
        type: String,
        default: null
      },
      value: {
        type: [Number, String],
        default: null
      },
      options: {
        type: Array,
        default: () => []
      },
      disabled: {
        type: Boolean,
        default: false
      },
      placeholder: {
        type: String,
        default: '請選擇'
      },
      loading: {
        type: Boolean,
        default: false
      },
      searchable: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      val: {
        get() {
          const { options, value } = this;
          if (!value) return null;
          return options.find(option => option.value === value);
        },
        set(obj) {
          if (!obj) return this.$emit('input', null);
          const { value } = obj;
          this.$emit('input', value);
        }
      }
    }
  };
</script>